module.exports = __webpack_public_path__ + "img/lishigushi-1@3x.a501822f.png";